"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _ArrayHelper = require("../../helpers/ArrayHelper");

var _config = _interopRequireDefault(require("../../../targets/cord_sanofi/config.js"));

var _AppCordova = _interopRequireDefault(require("../../../targets/cord_sanofi/AppCordova.js"));

var _HomeCordova = _interopRequireDefault(require("./HomeCordova/HomeCordova"));

var _SettingsCordova = _interopRequireDefault(require("./SettingsCordova/SettingsCordova"));

var _UserInfo = _interopRequireDefault(require("./UserInfo/UserInfo"));

var _Constants = require("../constants/Constants");

var _TopicChooser = _interopRequireDefault(require("./TopicChooser/TopicChooser"));

var _UpdatePage = _interopRequireDefault(require("./UpdatePage/UpdatePage"));

// noinspection Eslint
// eslint-disable-line
var i = 0;
var defaultRoutes = [/*#__PURE__*/_react["default"].createElement(_reactRouter.IndexRoute, {
  key: 'Route-Index',
  component: _HomeCordova["default"]
}),
/*#__PURE__*/
// <Route key={`Route-Default-${i++}`} path="about(/:id)" component={About} />,
// <Route key={`Route-Default-${i++}`} path="equeo_external_website/:id" component={ExternalWebsite} externalWebsiteSendsMessages />,
// <Route key={`Route-Default-${i++}`} path="external_website/:id" component={ExternalWebsite} externalWebsiteSendsMessages={false} />,
_react["default"].createElement(_reactRouter.Route, {
  key: "Route-Default-".concat(i++),
  path: "".concat(_Constants.SETTINGS_PATH, "(/:id)"),
  component: _SettingsCordova["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-Default-".concat(i++),
  path: "".concat(_Constants.TOPIC_CHOOSER_PATH, "(/:id)"),
  component: _TopicChooser["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-Default-".concat(i++),
  path: "".concat(_Constants.USER_PATH, "(/:id)"),
  component: _UserInfo["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-Default-".concat(i++),
  path: "".concat(_Constants.REGISTER_PATH),
  component: _HomeCordova["default"]
}), /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  key: "Route-Default-".concat(i++),
  path: "".concat(_Constants.UPDATE_PATH),
  component: _UpdatePage["default"]
})]; //

var routes = /*#__PURE__*/_react["default"].createElement(_reactRouter.Route, {
  path: "/",
  component: _AppCordova["default"]
}, (0, _ArrayHelper.flattenArray)(defaultRoutes.concat(_config["default"].targetFeatures.map(function (feature) {
  return feature.FEATURE_ROUTES;
}))));

var _default = routes;
exports["default"] = _default;